export default __webpack_public_path__ + "static/media/chapman_thumb.be0bc38f.jpg";